export default __webpack_public_path__ + "static/audio-cardio-2-c-34a229d1e2698d8d660bc455d774280a.webp";